import React from 'react';
import { Check } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/3Jj4zMJBLUdVTgs6oRiUHJ/image.png',
  title: 'Juegos Lectores en Familia',
  desc: '20 dinámicas para practicar juntos.',
  value: '$27'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/rbx9c8mncAfJx6Mkwaet15/image.png',
  title: 'Hojas de Ejercicios',
  desc: '50 actividades listas para imprimir.',
  value: '$19'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/qTT8HbkX9SeEKkCb68QnqD/image.png',
  title: 'Audiocuentos',
  desc: 'Cuentos narrados para escuchar juntos.',
  value: '$25'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/iZGsPTwEiGtNh5ah6oDshs/image.png',
  title: 'Pack Silábico',
  desc: 'Cartillas para practicar sílabas.',
  value: '$15'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/49CrGm3QRz7egjDYa5CWNY/image.png',
  title: 'Lecturas Ilustradas',
  desc: 'Textos cortos con imágenes.',
  value: '$22'
}];
export function BonusesSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const totalValue = bonuses.reduce((sum, b) => sum + parseInt(b.value.replace('$', '')), 0);
  return <section className="pt-6 pb-10 px-4 bg-gradient-to-b from-white to-purple-50" data-id="element-14">
      <div className="max-w-2xl mx-auto" data-id="element-15">
        <div className="text-center mb-8" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-2" data-id="element-17">
            Además llevas estos 5
          </h2>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-3" data-id="element-18">
            regalos valorados en ${totalValue}
          </h2>
          <p className="text-gray-600 text-base" data-id="element-19">
            Incluidos <span className="font-bold" data-id="element-20">GRATIS</span> si accedes hoy
            <br data-id="element-21" />
            (normalmente se venden por separado)
          </p>
        </div>

        <div ref={ref} className={`flex flex-col gap-4 ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-22">
          {bonuses.map((bonus, index) => <div key={index} className="flex items-center gap-4 bg-white rounded-2xl border border-gray-200 p-4 shadow-sm" data-id="element-23">
              <img src={bonus.image} alt={bonus.title} className="w-20 h-20 object-contain rounded-xl shrink-0" data-id="element-24" />

              <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-25">
                <Check className="w-5 h-5 text-teal-500 shrink-0 mt-0.5" strokeWidth={3} data-id="element-26" />
                <div className="min-w-0" data-id="element-27">
                  <h3 className="text-base font-bold text-gray-800 leading-tight" data-id="element-28">
                    {bonus.title}
                  </h3>
                  <p className="text-sm text-gray-500 mt-0.5" data-id="element-29">{bonus.desc}</p>
                  <div className="flex items-center gap-2 mt-1 text-xs" data-id="element-30">
                    <span className="text-gray-400 line-through" data-id="element-31">
                      Valor: {bonus.value}
                    </span>
                    <span className="text-purple-600 font-bold" data-id="element-32">Hoy: $0</span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}